/**
 *
 * NotFoundPage
 *
 * This is the page we show when the user visits a url that doesn't have a route
 */

import React from "react";
import { withStyles } from "@envestnet/envreact-component-library";
import AppBar from "../../components/AppBar";
import withIntl from "../../utils/withIntl";
import styles, { Styles } from "./styles";
import messages from "./messages";

type Props = Styles & {
  formatMessage: FormatMessage;
};

function NotFound(props: Props) {
  const { classes, formatMessage } = props;
  return (
    <div className={classes.container}>
      <AppBar className={classes.header} />
      <div className={classes.body}>
        <div className={classes.menu} />
        <div className={classes.main}>
          <div className={classes.contentContainer}>
            <div className={classes.errorHeader}>
              {formatMessage(messages.mainHeader)}
            </div>
            <div className={classes.errorCode}>
              {formatMessage(messages.errorCode)}
            </div>
          </div>
        </div>
        <div className={classes.info} />
      </div>
    </div>
  );
}
export default withStyles(styles)(withIntl(NotFound));
